import React from "react";

export interface TeamMemberCardProps {
  name: string;
  role: string;
  imageSrc: string;
  /** CSS object-position for the image (e.g. "center 25%" to show upper part / face) */
  imagePosition?: string;
  onOpenProfile: () => void;
  viewProfileLabel: string;
}

export function TeamMemberCard({
  name,
  role,
  imageSrc,
  imagePosition,
  onOpenProfile,
  viewProfileLabel,
}: TeamMemberCardProps): React.ReactElement {
  return (
    <article className="flex flex-col items-center rounded-2xl text-center max-w-[560px]">
      <button
        type="button"
        onClick={onOpenProfile}
        className="w-64 h-64 rounded-full border-2 border-gold overflow-hidden shrink-0 bg-gray-200 relative cursor-pointer p-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 transition-opacity hover:opacity-95"
        aria-label={viewProfileLabel}
      >
        <img
          src={imageSrc}
          alt={name}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover pointer-events-none"
          style={imagePosition ? { objectPosition: imagePosition } : undefined}
        />
      </button>
      <div className="p-8 flex flex-col gap-2 w-full">
        <button
          type="button"
          onClick={onOpenProfile}
          aria-label={viewProfileLabel}
          className="text-navy text-2xl font-semibold tracking-tight hover:text-gold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 rounded-lg cursor-pointer"
        >
          {name}
        </button>
        <p className="text-gray-body text-lg font-medium leading-relaxed whitespace-pre-line">
          {role}
        </p>
      </div>
    </article>
  );
}

export default TeamMemberCard;
